//@ts-nocheck
/* 
 *  This file file-upload.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { Injectable } from '@angular/core';
import { HttpService } from './http-service';
import { SnackbarAlertService } from './snackbar-alert.service';
// import * as fileSaver from 'file-saver';
// import * as mime from 'mime-types';
import { contentTypes } from '../models/hrone-file.model';
import { forkJoin, map, Observable, of, switchMap } from 'rxjs';

// import * as mime from 'mime';
const mime = require('mime/lite');

export type UploadFileApiType = 'file' | 'userFile' | 'image' | 'compressImage';

export interface UploadFileModel {
    apiType: UploadFileApiType;
    File: File;
    FolderName?: string;  // if apiType == file || apiType ==  image || apiType ==  compressImage
    FileExtensionsAllow?: number;   // if apiType == file || apiType ==  userFile
    EmployeeCode?: string;    // if apiType == userFile
    ModuleName?: string;       // if apiType == userFile
    ProcessName?: string;     // if apiType == userFile
    CompressRatio?: number;   // if  apiType ==  compressImage
    FileMaxSize?: string;
}

export interface FileResponseModel {
    fileName: string;
    fileDbName: string;
    resizedImageDbFileName: string;
    folderName: string;
}

export const fileUrls = {
    fileVirtualUrl: '/api/core/File/FileVirtualUrl?fileDbName=',
    fileUpload: '/api/hrops/file/Upload',
    fileUploadUser: '/api/core/File/UploadUserFile',
    imageResizeUpload: '/api/core/file/UploadResizeImage',
    download: '/api/core/file/Download?fileDbName=',
    compressImage: '/api/core/file/UploadCustomImage',
    trimedFileVirtualUrl: '/api/core/file/UrlPathEncode/FileVirtualUrl',
    externalfileVirtualUrl: '/api/external/access/FileVirtualUrl?fileDbName=',
    externalfileUploadUser: '/api/external/access/UploadUserFile'
};

export type FileType = 'image' | 'video' | 'audio' | 'file';

@Injectable()
export class FileUploadService {

    fileSize: any = '5MB';

    fileValidation = {
        0: {                  // for resize image upload
            size: 5242880,
            types: ['png', 'jpg', 'jpeg', 'bmp'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are jpeg, jpg, png, bmp'
        },
        1: {
            size: 5242880,
            types: ['jpeg', 'jpg', 'png', 'bmp'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are jpeg, jpg, png, bmp'
        },
        2: {
            size: 5242880,
            types: ['pdf', 'doc', 'docx', 'txt'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are pdf, doc, docx, txt'
        },
        3: {
            size: 5242880,
            types: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'png'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are pdf, doc, docx, xls, xlsx, png'
        },
        4: {
            size: 5242880,
            types: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png', 'bmp', 'zip', 'rar'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are pdf, doc, docx, xls, xlsx, jpeg, jpg, png, bmp, zip, rar'
        },
        5: {
            size: 5242880,
            types: ['xlsx'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File format allowed is xlsx '
        },
        6: {
            size: 5242880,
            types: ['pdf', 'doc', 'docx', 'txt', 'xls', 'xlsx', 'jpeg', 'jpg', 'png', 'bmp'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are pdf, doc, docx, txt, xls, xlsx, jpeg, jpg, png, bmp'
        },
        7: {
            size: 5242880,
            types: ['pdf', 'doc', 'docx', 'jpeg', 'jpg', 'png', 'bmp'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are pdf, doc, docx, jpeg, jpg, png, bmp '
        },
        8: {
            size: 5242880,
            types: ['pdf'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File format allowed is  pdf '
        },
        9: {
            size: 5242880,
            types: ['doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png', 'bmp'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are doc, docx, xls, xlsx, jpeg, jpg, png, bmp '
        },
        10: {
            size: 5242880,
            types: ['pdf', 'doc', 'docx', 'xls', 'xlsx'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are pdf, doc, docx, xls, xlsx '
        },
        11: {
            size: 5242880,
            types: ['xls', 'xlsx'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are xls, xlsx'
        },
        12: {
            size: 5242880,
            types: ['doc', 'docx'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are doc, docx'
        },
        13: {
            size: 5242880,
            types: ['doc', 'docx', 'txt', 'rtf', 'pdf', 'html', 'htm'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed are doc, docx, txt, rtf, pdf, html, htm'
        },

        14: {
            size: 5242880,
            types: ['zip'],
            sizeMessage: 'Maximum file allowed size is 5MB',
            typeMessage: 'File formats allowed  zip'
        },
        15: {
            size: 20971520,
            types: ['zip'],
            sizeMessage: 'Maximum file allowed size is 20MB',
            typeMessage: 'File formats allowed  zip'
        }
    };

    constructor(
        private _httpService: HttpService,
        public _snackBar: SnackbarAlertService,
    ) { }

    // getFileConfig() {
    //     this._httpService.Get('assets/json/config.json').subscribe(response => {
    //         const fileSizeInByte = response['file_size_in_mb'] * 1048576;
    //         if (fileSizeInByte) {
    //             this.fileSize = this.convertByteTo(fileSizeInByte);
    //             Object.keys(this.fileValidation).forEach(element => {
    //                 this.fileValidation[element].size = fileSizeInByte;
    //                 this.fileValidation[element].sizeMessage = 'Maximum file allowed size is ' + this.fileSize;
    //             });
    //         }
    //     });
    // }

    convertByteTo(bytes) {
        if (bytes === 0) {
            return '0 B';
        }
        const k = 1000,
            dm = 3,
            sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];

    }

    getFileValidation(file, key) {
        const fileSize = this.fileValidation[key].size;
        const fileTypes = this.fileValidation[key].types;

        // check extention
        const ext = this.getFileExtention(file.name).toLowerCase();
        if (fileTypes.indexOf(ext) < 0) {
            this._snackBar.Alert(this.fileValidation[key].typeMessage, '3');
            return false;
        }
        // end ext

        // size validation
        if (file.size > fileSize) {
            this._snackBar.Alert(this.fileValidation[key].sizeMessage, '3');
            return false;
        }
        // end size

        return true;

    }

    getFileTypeValidation(file, key) {
        const fileTypes = this.fileValidation[key].types;

        // check extention
        const ext = this.getFileExtention(file.name).toLowerCase();
        if (fileTypes.indexOf(ext) < 0) {
            this._snackBar.Alert(this.fileValidation[key].typeMessage, '3');
            return false;
        }
        // end ext

        return true;

    }

    getFileExtention(name) {
        try {
            if (name) {
                return name.split('.').pop().toLowerCase();
            }
        } catch (err) {

        }

        return name;
    }

    uploadFile(payload: UploadFileModel, ignoreSize?): Promise<any> {
        console.log('payload', payload);
        return new Promise((resolve, reject) => {
            const fileExtensionKey = payload.FileExtensionsAllow ? payload.FileExtensionsAllow : 0;
            let flag;
            if (ignoreSize) {
                flag = this.getFileTypeValidation(payload.File, fileExtensionKey);
            } else {
                flag = this.getFileValidation(payload.File, fileExtensionKey);
            }

            if (flag) {

                const formData = new FormData();
                formData.append('File', payload.File);
                formData.append('FolderName', payload.FolderName);
                let url = fileUrls.imageResizeUpload;
                if (payload.apiType === 'compressImage') {
                    url = fileUrls.compressImage;
                    formData.append('CompressionRatio', payload.CompressRatio ? String(payload.CompressRatio) : '50');
                } else if (payload.apiType === 'file') {
                    url = fileUrls.fileUpload;
                    formData.append('FileExtensionsAllow', String(payload.FileExtensionsAllow));
                    if (payload.FileMaxSize) {
                        formData.append('FileMaxSize', payload.FileMaxSize);
                    }
                } else if (payload.apiType === 'userFile') {
                    url = fileUrls.fileUploadUser;
                    formData.append('FileExtensionsAllow', String(payload.FileExtensionsAllow));
                    formData.append('ModuleName', payload.ModuleName ? payload.ModuleName : '');
                    formData.append('ProcessName', payload.ProcessName ? payload.ProcessName : '');
                    formData.append('EmployeeCode', payload.EmployeeCode ? payload.EmployeeCode : '');
                }

                this._httpService.PostFile(url, formData)
                    .subscribe(
                        (response) => {
                            resolve(response);
                        },
                        err => {
                            reject(new Error("Whoops server error!"));
                        });
            } else {
                reject(new Error("Whoops client error!"));
            }
        });
    }

    uploadExternalFile(payload: UploadFileModel, appId, domainCode, ignoreSize?): Promise<any> {
        console.log('payload', payload);
        return new Promise((resolve, reject) => {
            const fileExtensionKey = payload.FileExtensionsAllow ? payload.FileExtensionsAllow : 0;
            let flag;
            if (ignoreSize) {
                flag = this.getFileTypeValidation(payload.File, fileExtensionKey);
            } else {
                flag = this.getFileValidation(payload.File, fileExtensionKey);
            }

            if (flag) {
                const formData = new FormData();
                formData.append('File', payload.File);
                formData.append('FolderName', payload.FolderName);
                let url = fileUrls.imageResizeUpload;
                if (payload.apiType === 'file') {
                    url = '/api/external/access/File/Upload';
                    formData.append('FileExtensionsAllow', String(payload.FileExtensionsAllow));
                } else if (payload.apiType === 'userFile') {
                    url = '/api/external/access/UploadUserFile';
                    formData.append('FileExtensionsAllow', String(payload.FileExtensionsAllow));
                    formData.append('ModuleName', payload.ModuleName ? payload.ModuleName : '');
                    formData.append('ProcessName', payload.ProcessName ? payload.ProcessName : '');
                    formData.append('EmployeeCode', payload.EmployeeCode ? payload.EmployeeCode : '');
                }

                this._httpService.PostExternalFile(url, appId, domainCode, formData)
                    .subscribe(
                        (response) => {
                            resolve(response);
                        },
                        err => {
                            reject(new Error("Whoops server error!"));
                        });
            } else {
                reject(new Error("Whoops client error!"));
            }
        });
    }

    getFileVirtualPath(fileDbName): Promise<any> {
        return new Promise((resolve, reject) => {
            if (fileDbName) {
                const query = encodeURIComponent(fileDbName);
                const url = fileUrls.fileVirtualUrl + query + "&requestSource=null";
                this._httpService.Get(url).subscribe(
                    resp => {
                        if (resp && resp.fileVirtualPath) {
                            resolve(resp.fileVirtualPath);
                        } else {
                            reject(new Error("Whoops server error!"));
                        }
                    }, err => {
                        reject(new Error("Whoops client error!"));
                    });
            } else {
                reject(new Error("Whoops client error!"));
            }
        });
    }

    getTrimedFileVirtualPath(fileDbName): Promise<any> {
        return new Promise((resolve, reject) => {
            if (fileDbName) {
                const url = fileUrls.trimedFileVirtualUrl + `?fileDbName=${fileDbName}` + "&requestSource=null";
                this._httpService.Get(url).subscribe(
                    resp => {
                        if (resp && resp.fileVirtualPath) {
                            resolve(resp.fileVirtualPath);
                        } else {
                            reject(new Error("Whoops server error!"));
                        }
                    }, err => {
                        reject(new Error("Whoops client error!"));
                    });
            } else {
                reject(new Error("Whoops client error!"));
            }
        });
    }

    getBase64(fileDbName): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpService.Get(fileUrls.download + fileDbName).subscribe(
                resp => {
                    if (resp && resp.byteArray) {
                        resolve(resp.byteArray);
                    } else {
                        reject(new Error("Whoops server error!"));
                    }
                }, err => {
                    reject(new Error("Whoops client error!"));
                });
        });
    }

    downloadFileByFileDbName(fileDbName, fileName) {
        this.getBase64(fileDbName).then(res => {
            this.downloadFileByBase64(res, fileName);
        });
    }

    downloadFileByBase64(base64String, fileName) {
        // const blob = this.getBlob(base64String, fileName);
        // fileSaver.saveAs(blob, fileName);
    }

    getBlob(base64String, fileName) {
        const contentType = this.getContentType(fileName);
        const blob = this.b64toBlob(base64String, contentType);
        return blob;
    }

    b64toBlob(b64Data, contentType = '', sliceSize = 512) {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    getContentType(fileName) {
        const ext = this.getFileExtention(fileName);
        if (contentTypes[ext]) {
            return contentTypes[ext];
        }
        return "text/plain";
    }

    isImage(fileName) {
        const ext = this.getFileExtention(fileName);
        const list = this.fileValidation['0'].types;
        if (list.indexOf(ext) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    isFileViewable(fileName) {
        const ext = this.getFileExtention(fileName);
        const list = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'];
        if (list.indexOf(ext) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    // downloadFile(path: any) {
    //     if (path &&
    //         (path.indexOf('https://') !== -1
    //             || path.indexOf('http://') !== -1)) {
    //         window.location.href = path;

    //     }
    // }

    downloadFile(path) {
        if (path) {
            const varExt = path.split('.');
            if (varExt[varExt.length - 1] == "txt") {
                window.open(path, '_blank');
            } else {
                let iframe;
                iframe = document.getElementById("hiddenDownloader");
                if (!iframe) {
                    iframe = document.createElement('iframe');
                    iframe.id = "hiddenDownloader";
                    iframe.style.display = 'none';
                    document.body.appendChild(iframe);
                }
                iframe.src = path;
            }
        }
        // return false;
    }

    getFileType(fileName) {
        let val: FileType = 'file';
        const type = mime.getType(fileName);
        if (type) {
            const t = type.split('/')[0];
            if (t == 'image') {
                val = 'image';
            } else if (t == 'video') {
                val = 'video';
            } else if (t == 'audio') {
                val = 'audio';
            }
        }

        console.log(fileName, type);

        return val;
    }
    processHtmlAndUpload(htmlContent: string, folderName: string, source: string = 'Hrops') {
        if (!htmlContent) return of('');

        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');
        const images = Array.from(doc.querySelectorAll('img'));
        const uploadObservables = images.filter(img => img.src.startsWith('data:image')).map(img => this.uploadImage(img.src, folderName, source).pipe(map(response => ({ img, blobUrl:response.fileVirtualPath }))));

        if (uploadObservables.length) {
            return forkJoin(uploadObservables).pipe(
                switchMap(results => {
                    results.forEach(({ img, blobUrl }) => (img.src = blobUrl));
                    return this.uploadHtmlFile(doc.body.innerHTML, folderName, source)
                })
            )
        }
        return this.uploadHtmlFile(doc.body.innerHTML, folderName, source)
    }

    uploadImage(base64: string, folderName: string, source: string) {
        const file = this.base64ToFile(base64);
        const formData = new FormData();
        formData.append('File', file);
        formData.append('FolderName', folderName);
        formData.append('FileExtensionsAllow', '1');
        formData.append('source', source);
        return this._httpService.PostFile('/api/super/file/Upload', formData)
    }
    base64ToFile(base64: string): File {
        const [header, base64Data] = base64.split(',');
        const mimeMatch = header.match(/:(.*?);/);
        const mimeType = mimeMatch ? mimeMatch[1] : 'image/png';
        const extension = this.getFileExtension(mimeType);
        const byteString = atob(base64Data);
        const buffer = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            buffer[i] = byteString.charCodeAt(i);
        }
        return new File([new Blob([buffer], { type: mimeType })], `image_${Date.now()}.${extension}`, {
            lastModified: Date.now(),
            type: mimeType,
        });
    }
    getFileExtension(mimeType: string): string {
        const extensions = { 'image/jpeg': 'jpg', 'image/jpg': 'jpg', 'image/png': 'png' };
        return extensions[mimeType] || 'png';
    }
    createTextFile(content: string): File {
        const utf8BOM = new Uint8Array([0xEF, 0xBB, 0xBF]);
        const textUint8 = new TextEncoder().encode(content);
        const combined = new Uint8Array(utf8BOM.length + textUint8.length);
        combined.set(utf8BOM, 0);
        combined.set(textUint8, utf8BOM.length);

        return new File([new Blob([combined], { type: 'text/plain' })], `file_${Date.now()}.txt`, {
            type: 'text/plain',
        });
    }

    uploadHtmlFile(htmlContent: string, folderName: string, source: string):Observable<any> {
        const file = this.createTextFile(htmlContent);
        const formData = new FormData();
        formData.append('File', file);
        formData.append('FolderName', folderName);
        formData.append('FileExtensionsAllow', '2');
        formData.append('source', source);
        return this._httpService.PostFile('/api/super/file/Upload', formData);
    }
}
